import React from 'react';

const WEEKDAYS = [
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
  'Sun',
];

const formatHour12 = (hour) => {
  const h = Number(hour);

  if (!Number.isFinite(h) || h < 0 || h > 23) {
    return '';
  }

  const suffix = h < 12 ? 'AM' : 'PM';
  const hour12 = h % 12 === 0 ? 12 : h % 12;

  return `${hour12}:00 ${suffix}`;
};

const OrdersHeatmap = ({
  data = [],
  isDark = false,
}) => {

  const keyToCount = new Map();
  let max = 0;

  for (const row of data) {
    const weekday = Number(row?.weekday_index);
    const hour = Number(row?.hour_of_day);
    const count = Number(row?.total_orders || 0);

    if (
      !Number.isFinite(weekday) ||
      !Number.isFinite(hour) ||
      weekday < 0 ||
      weekday > 6 ||
      hour < 0 ||
      hour > 23
    ) {
      continue;
    }

    keyToCount.set(
      `${weekday}-${hour}`,
      count
    );

    max = Math.max(max, count);
  }

  const heatColor = (count) => {
    if (!count || !max) {
      return isDark
        ? 'rgba(59, 130, 246, 0.08)'
        : 'rgba(59, 130, 246, 0.06)';
    }

    const intensity = count / max;
    const alpha = 0.15 + 0.85 * intensity;

    return `rgba(37, 99, 235, ${alpha.toFixed(3)})`;
  };

  if (!data.length) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400">
        No data available for peak-hour heatmap.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">

      <div className="min-w-[920px]">

        <div
          className="grid"
          style={{
            gridTemplateColumns:
              '80px repeat(24, minmax(24px, 1fr))',
          }}
        >

          {/* Empty corner */}
          <div />

          {/* Hours */}
          {Array.from(
            { length: 24 },
            (_, hour) => (
              <div
                key={`hour-${hour}`}
                className="text-[10px] text-gray-500 dark:text-gray-400 text-center mb-1"
              >
                {formatHour12(hour)}
              </div>
            )
          )}

          {/* Days */}
          {WEEKDAYS.map((day, dayIndex) => (
            <React.Fragment key={`row-${day}`}>

              <div className="text-xs text-gray-700 dark:text-gray-300 pr-2 py-1">
                {day}
              </div>

              {Array.from(
                { length: 24 },
                (_, hour) => {

                  const count =
                    Number(
                      keyToCount.get(
                        `${dayIndex}-${hour}`
                      ) || 0
                    );

                  return (
                    <div
                      key={`${day}-${hour}`}
                      className="h-6 border border-white dark:border-gray-800"
                      style={{
                        backgroundColor:
                          heatColor(count),
                      }}
                      title={`${day} ${formatHour12(hour)} - ${count.toLocaleString()} orders`}
                    />
                  );
                }
              )}

            </React.Fragment>
          ))}

        </div>

      </div>

    </div>
  );
};

export default OrdersHeatmap;